<div class="gtmpage-browse-by-grade">
    <ng-container *ngIf="gradeBand">
        <div class="banner mt-5 me-0 mb-7 ms-7">
            <div class="container">
                <div class="row-auto me-0 me-md-n4">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="header">
                            <h1 class="title selenium-grade-title">{{ gradeBand.label }}</h1>
                        </div>
                        <div class="description selenium-grade-description mt-4">
                            {{ gradeBand.description }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-0 p-md-8 m-md-auto mw-1400">
            <div class="me-0 me-md-n row-auto browsing-content-wrapper" id="resultsWrapper">
                <div class="pe-0 pe-md-1 col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <app-browse-by-grade-results-group
                        [gradeBand]="gradeBand"
                        [resultsPerRow]="4"
                    ></app-browse-by-grade-results-group>
                </div>
            </div>
        </div>
    </ng-container>
    <app-available-features></app-available-features>
</div>
